/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BlockRoleDto } from '../models/BlockRoleDto';
import type { CreateRoleDto } from '../models/CreateRoleDto';
import type { UpdatePermissionsDto } from '../models/UpdatePermissionsDto';
import type { UpdateRoleDto } from '../models/UpdateRoleDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class RolesService {
  /**
   * @param requestBody
   * @returns any
   * @throws ApiError
   */
  public static rolesControllerCreate(requestBody: CreateRoleDto): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/roles',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param page Page number (1-based)
   * @param limit Number of items per page
   * @param searchTerm Search term to filter by name or description
   * @param status Filter by status (active/blocked)
   * @param startDate Start date for filtering by creation date (ISO string)
   * @param endDate End date for filtering by creation date (ISO string)
   * @param sortBy Field to sort by
   * @returns any
   * @throws ApiError
   */
  public static rolesControllerFindAll(
    page: number = 1,
    limit: number = 10,
    searchTerm?: string,
    status?: 'all' | 'active' | 'blocked',
    startDate?: string,
    endDate?: string,
    sortBy?: 'name' | 'createdAt' | 'userCount',
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/roles',
      query: {
        page: page,
        limit: limit,
        searchTerm: searchTerm,
        status: status,
        startDate: startDate,
        endDate: endDate,
        sortBy: sortBy,
      },
    });
  }
  /**
   * @returns any
   * @throws ApiError
   */
  public static rolesControllerGetAllRoles(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/roles/all',
    });
  }
  /**
   * @param id
   * @returns any
   * @throws ApiError
   */
  public static rolesControllerFindOne(id: string): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/roles/{id}',
      path: {
        id: id,
      },
    });
  }
  /**
   * @param id
   * @param requestBody
   * @returns any
   * @throws ApiError
   */
  public static rolesControllerUpdate(
    id: string,
    requestBody: UpdateRoleDto,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/roles/{id}',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param id
   * @returns any
   * @throws ApiError
   */
  public static rolesControllerRemove(id: string): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/roles/{id}',
      path: {
        id: id,
      },
    });
  }
  /**
   * @param id
   * @returns any
   * @throws ApiError
   */
  public static rolesControllerGetPermissions(id: string): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/roles/{id}/permissions',
      path: {
        id: id,
      },
    });
  }
  /**
   * @param id
   * @param requestBody
   * @returns any
   * @throws ApiError
   */
  public static rolesControllerUpdatePermissions(
    id: string,
    requestBody: UpdatePermissionsDto,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/roles/{id}/permissions',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param id
   * @param requestBody
   * @returns any
   * @throws ApiError
   */
  public static rolesControllerBlockRole(
    id: string,
    requestBody: BlockRoleDto,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/roles/{id}/block',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Unblock a role
   * @param id Role ID
   * @returns any Role unblocked successfully
   * @throws ApiError
   */
  public static rolesControllerUnblockRole(id: string): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/roles/{id}/unblock',
      path: {
        id: id,
      },
      errors: {
        404: `Role not found`,
      },
    });
  }
  /**
   * Get users with a specific role
   * @param id Role ID
   * @returns any Users retrieved successfully
   * @throws ApiError
   */
  public static rolesControllerGetUsersWithRole(id: string): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/roles/{id}/users',
      path: {
        id: id,
      },
      errors: {
        404: `Role not found`,
      },
    });
  }
  /**
   * Copy a role with its permissions
   * @param id Role ID to copy
   * @param requestBody
   * @returns any Role copied successfully
   * @throws ApiError
   */
  public static rolesControllerCopyRole(
    id: string,
    requestBody?: {
      /**
       * Optional new name for the copied role
       */
      name?: string;
    },
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/roles/{id}/copy',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Role not found`,
      },
    });
  }
  /**
   * Export roles to CSV
   * @returns any CSV file generated successfully
   * @throws ApiError
   */
  public static rolesControllerExportRoles(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/roles/export/csv',
    });
  }
}
